import { useLazyQuery } from '@apollo/client';

import { downloadImageQuery } from './gql';
import { IDownloadImageVariables, IQueryResult } from './interfaces';

export const useDownloadImagesGql = () => {
  const [runDownloadImageGql, { loading, data, error }] = useLazyQuery<IQueryResult, IDownloadImageVariables>(
    downloadImageQuery,
    {
      context: {
        headers: {
          userFunctionKey: 'a684eceee76fc522773286a895bc8436'
        }
      }
    }
  );

  return {
    runDownloadImageGql,
    loadingDownloadImage: loading,
    base64Data: data?.downloadImage.base64Data || [],
    errorDownloadImage: error
  };
};
